(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ee-featured-product"] && !Shopify.designMode) return;
  try {
    
  class EeFeatureGallery extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const thumb = event.target instanceof Element ? event.target.closest('.ee-feature__thumb') : null;
        if (!thumb) return;
        const index = thumb.getAttribute('data-index');
        for (const slide of this.querySelectorAll('.ee-feature__slide')) {
          slide.classList.toggle('is-active', slide.getAttribute('data-index') === index);
        }
        for (const t of this.querySelectorAll('.ee-feature__thumb')) {
          if (t === thumb) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        }
      });
    }
  }

  if (!customElements.get('ee-feature-gallery')) customElements.define('ee-feature-gallery', EeFeatureGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-kit-finder"] && !Shopify.designMode) return;
  try {
    
  class EeKitFinder extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-form]');
      this.steps = [...this.querySelectorAll('[data-step]')];
      this.nextBtn = this.querySelector('[data-next]');
      this.backBtn = this.querySelector('[data-back]');
      this.results = this.querySelector('[data-results]');
      this.cards = this.querySelector('[data-cards]');
      this.bar = this.querySelector('[data-progress]');
      this.kits = JSON.parse(this.querySelector('[data-kits]').textContent || '[]');
      this.labels = {};
      this.querySelector('[data-labels]').content.querySelectorAll('[data-key]').forEach((el) => (this.labels[el.dataset.key] = el.textContent));
      this.index = 0;
      this.form.addEventListener('change', () => this.update());
      this.nextBtn.addEventListener('click', () => this.go(1));
      this.backBtn.addEventListener('click', () => this.go(-1));
      this.querySelector('[data-restart]').addEventListener('click', () => this.restart());
      this.update();
    }

    current() {
      return this.steps[this.index].querySelector('input:checked');
    }

    update() {
      this.nextBtn.disabled = !this.current();
      this.backBtn.hidden = this.index === 0;
      this.bar.style.width = `${((this.index + (this.current() ? 1 : 0)) / this.steps.length) * 100}%`;
    }

    go(dir) {
      if (dir > 0 && this.index === this.steps.length - 1) return this.show();
      this.steps[this.index].hidden = true;
      this.index = Math.max(0, Math.min(this.steps.length - 1, this.index + dir));
      this.steps[this.index].hidden = false;
      const first = this.steps[this.index].querySelector('input');
      if (first) first.focus();
      this.update();
    }

    restart() {
      this.form.reset();
      this.results.hidden = true;
      this.form.hidden = false;
      this.steps.forEach((s, i) => (s.hidden = i !== 0));
      this.index = 0;
      this.update();
      this.steps[0].querySelector('input')?.focus();
    }

    show() {
      const data = Object.fromEntries(new FormData(this.form));
      const limit = data.budget === 'under50' ? 5000 : data.budget === 'under150' ? 15000 : Infinity;
      const scored = this.kits
        .map((kit) => {
          let score = 0;
          if (kit.topics.includes(data.topic)) score += 4;
          if (kit.levels.includes(data.level)) score += 2;
          if (kit.interests.includes(data.interest)) score += 3;
          if (kit.price <= limit) score += 2;
          else score -= 3;
          if (!kit.available) score -= 2;
          if (kit.partner) score -= 1;
          return { kit, score };
        })
        .filter((s) => s.score > 0)
        .sort((a, b) => b.score - a.score)
        .slice(0, 3);

      this.cards.innerHTML = '';
      if (!scored.length) {
        const p = document.createElement('p');
        p.textContent = this.labels.none;
        this.cards.append(p);
      }
      scored.forEach(({ kit }, i) => this.cards.append(this.card(kit, i === 0)));
      this.form.hidden = true;
      this.results.hidden = false;
      this.bar.style.width = '100%';
      this.results.querySelector('h2').focus?.();
    }

    card(kit, top) {
      const el = document.createElement('article');
      el.className = 'ee-finder__card' + (top ? ' ee-finder__card--top' : '');
      const badge = document.createElement('span');
      badge.className = 'ee-finder__badge';
      badge.textContent = top ? this.labels.top : this.labels.alt;
      const media = document.createElement('a');
      media.href = kit.url;
      media.className = 'ee-finder__media';
      media.tabIndex = -1;
      if (kit.image) {
        const img = document.createElement('img');
        img.src = kit.image;
        img.alt = '';
        img.loading = 'lazy';
        media.append(img);
      }
      const body = document.createElement('div');
      body.className = 'ee-finder__body';
      const h = document.createElement('h3');
      const a = document.createElement('a');
      a.href = kit.url;
      a.textContent = kit.title;
      h.append(a);
      const price = document.createElement('p');
      price.className = 'ee-finder__price';
      price.textContent = kit.available ? kit.price_label : `${kit.price_label} · ${this.labels.soldout}`;
      const reason = document.createElement('p');
      reason.className = 'ee-finder__reason';
      reason.textContent = kit.reason;
      body.append(badge, h, price, reason);
      if (kit.partner) {
        const note = document.createElement('p');
        note.className = 'ee-finder__partner';
        note.textContent = this.labels.partner;
        body.append(note);
      }
      const actions = document.createElement('div');
      actions.className = 'ee-finder__actions';
      const view = document.createElement('a');
      view.href = kit.url;
      view.className = 'button';
      view.textContent = this.labels.view;
      actions.append(view);
      if (kit.learn_url && kit.learn_label) {
        const learn = document.createElement('a');
        learn.href = kit.learn_url;
        learn.className = 'button button-secondary';
        learn.textContent = kit.learn_label;
        actions.append(learn);
      }
      body.append(actions);
      el.append(media, body);
      return el;
    }
  }
  if (!customElements.get('ee-kit-finder')) customElements.define('ee-kit-finder', EeKitFinder);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
